/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Gotomessages3Inputs */

const en_coinvestments_messages_gotomessages3 = /** @type {(inputs: Coinvestments_Messages_Gotomessages3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to messages`)
};

/**
* | output |
* | --- |
* | "Go to messages" |
*
* @param {Coinvestments_Messages_Gotomessages3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_gotomessages3 = /** @type {((inputs?: Coinvestments_Messages_Gotomessages3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Gotomessages3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_gotomessages3(inputs)
});
export { coinvestments_messages_gotomessages3 as "coInvestments_messages_goToMessages" }